
import { defineComponent, PropType } from 'vue'

// module components
import OrderReceiversListItem from '@/modules/EditOrderModule/components/OrderReceiversListItem/index.vue'

// types
import { FullOrderReceiverT } from '@/core/types/orders.types'

export default defineComponent({
    components: {
        'order-receivers-list-item': OrderReceiversListItem,
    },
    props: {
        receivers: {
            type: Array as PropType<FullOrderReceiverT[]>,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        withoutUpdate: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update-cargo'],
    setup(props, { emit }) {
        const emitUpdateCargo = (index: number) => {
            emit('update-cargo', index)
        }

        return { emitUpdateCargo }
    },
})
